import React, { useEffect, useContext, useState, useRef } from 'react';
import { AppContext } from '../../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../../assets/css/buttons.css';
import { SocketContext } from '../../../../context/SocketContext';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Flaky as FlakyIcon,
} from '@mui/icons-material/';
import { Box, Button, Typography } from '@mui/material';

function ModalPapirGameFinishedWithPrize() {
  const { t } = useTranslation();

  const {
    kioskHall,
    updateFocusOnMainScreen,
    updateShowModalPapirGameFinishedWithPrize,
    papirScannedInfo,
    updatePapirScannedInfo,
    userInfo,
    parentInfo,
    operator,
    session,
    hall,
    updateIsLoadingScreen,
    updateTransactions,
    updateTransactionsArray,
    currentUser,
    updateCurrentUser,
    updateUserLogin,
    updateUserInfo,
    maximumAnonPrizeAllowed,
    papirPrize,
    updatePapirPrize,
    updateShowModalPapirCheckCard,
    updatePapirCardInfo,
  } = useContext(AppContext);

  const kioskHallRef = useRef(kioskHall);
  useEffect(() => {
    kioskHallRef.current = kioskHall;
  }, [kioskHall]);

  const papirPrizeRef = useRef(papirPrize);
  useEffect(() => {
    papirPrizeRef.current = papirPrize;
  }, [papirPrize]);

  const maximumAnonPrizeAllowedRef = useRef(maximumAnonPrizeAllowed);
  useEffect(() => {
    maximumAnonPrizeAllowedRef.current = maximumAnonPrizeAllowed;
  }, [maximumAnonPrizeAllowed]);

  const currentUserRef = useRef(currentUser);
  useEffect(() => {
    currentUserRef.current = currentUser;
  }, [currentUser]);

  const hallRef = useRef(hall);
  useEffect(() => {
    hallRef.current = hall;
  }, [hall]);

  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const operatorRef = useRef(operator);
  useEffect(() => {
    operatorRef.current = operator;
  }, [operator]);

  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);

  const papirScannedInfoRef = useRef(papirScannedInfo);
  useEffect(() => {
    papirScannedInfoRef.current = papirScannedInfo;
  }, [papirScannedInfo]);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const handlePayoutPapirTicket = async (data) => {
      console.log('data payout', data);
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (parentInfoRef.current) {
        socket.emit('checkLimitStatus', {
          userInfo: parentInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      if (userInfoRef.current && userInfoRef.current.username !== 'Gjest') {
        socket.emit('checkLimitStatus', {
          userInfo: userInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      let allTrans = [];
      for (let i = 0; i < data.prizes.length; i++) {
        let singleTrans = {
          name: 'Utbetaling Papir Billett' + ' - ' + 'CH',
          amount: parseInt(data.prizes[i].amount) * -1,
          type: 'transaction',
        };
        allTrans.push(singleTrans);
      }

      updateTransactionsArray(allTrans);

      updatePapirScannedInfo(false);
      updateFocusOnMainScreen(true);
      updateShowModalPapirGameFinishedWithPrize(false);
    };

    const handlePayoutPapirKingoCard = async (data) => {
      console.log('data payout', data);
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (parentInfoRef.current) {
        socket.emit('checkLimitStatus', {
          userInfo: parentInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      if (userInfoRef.current && userInfoRef.current.username !== 'Gjest') {
        socket.emit('checkLimitStatus', {
          userInfo: userInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      let allTrans = [];
      for (let i = 0; i < data.prizes.length; i++) {
        let singleTrans = {
          name: 'Utbetaling Papir Kingo Billett' + ' - ' + 'CH',
          amount: parseInt(data.prizes[i].amount) * -1,
          type: 'transaction',
        };
        allTrans.push(singleTrans);
      }

      updateTransactionsArray(allTrans);

      updatePapirPrize('');

      updatePapirScannedInfo(false);
      updateFocusOnMainScreen(true);
      updateShowModalPapirGameFinishedWithPrize(false);
    };

    const handlePayoutPapirXtippCard = async (data) => {
      console.log('data payout', data);
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (parentInfoRef.current) {
        socket.emit('checkLimitStatus', {
          userInfo: parentInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      if (userInfoRef.current && userInfoRef.current.username !== 'Gjest') {
        socket.emit('checkLimitStatus', {
          userInfo: userInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      let allTrans = [];
      for (let i = 0; i < data.prizes.length; i++) {
        let singleTrans = {
          name: 'Utbetaling Papir Xtipp Billett' + ' - ' + 'CH',
          amount: parseInt(data.prizes[i].amount) * -1,
          type: 'transaction',
        };
        allTrans.push(singleTrans);
      }

      updateTransactionsArray(allTrans);

      updatePapirPrize('');

      updatePapirScannedInfo(false);
      updateFocusOnMainScreen(true);
      updateShowModalPapirGameFinishedWithPrize(false);
    };

    const handleGetPapirCardInfo = async (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      updatePapirCardInfo(data);
      updateShowModalPapirCheckCard(true);
    };

    socket.on('payoutPapirTicket', handlePayoutPapirTicket);
    socket.on('payoutPapirKingoCard', handlePayoutPapirKingoCard);
    socket.on('payoutPapirXtippCard', handlePayoutPapirXtippCard);
    socket.on('getPapirCardInfo', handleGetPapirCardInfo);
    return () => {
      socket.off('payoutPapirTicket', handlePayoutPapirTicket);
      socket.off('payoutPapirKingoCard', handlePayoutPapirKingoCard);
      socket.off('payoutPapirXtippCard', handlePayoutPapirXtippCard);
      socket.off('getPapirCardInfo', handleGetPapirCardInfo);
    };
  }, [socket]);

  const handleCheckCard = async () => {
    updateIsLoadingScreen(true);
    socket.emit('getPapirCardInfo', {
      bingoName: papirScannedInfoRef.current.bingoName,
      gameID: papirScannedInfoRef.current.gameID,
      ticketID: papirScannedInfoRef.current.ticketID,
    });
  };

  //* CONFIRM REGISTRATION BUTTON (search if phone exist or register the user)
  const handleConfirm = async () => {
    if (papirScannedInfoRef.current && papirScannedInfoRef.current.isPayout) {
      return;
    }

    if (
      papirScannedInfoRef.current &&
      papirScannedInfoRef.current.win >= maximumAnonPrizeAllowedRef.current &&
      (((!userInfoRef.current || !userInfoRef.current.username) &&
        !parentInfoRef.current) ||
        (userInfoRef.current &&
          !parentInfoRef.current &&
          userInfoRef.current.username === 'Gjest'))
    ) {
      return;
    }

    updateIsLoadingScreen(true);
    if (!currentUserRef.current) {
      updateCurrentUser('Gjest');
      updateUserLogin(true);
      updateUserInfo({ username: 'Gjest', firstname: 'Gjest' });
    }

    if (papirPrizeRef.current === 'kingo') {
      socket.emit('payoutPapirKingoCard', {
        ticketID: papirScannedInfoRef.current.ticketID,
        prizes: papirScannedInfoRef.current.prizes,
        operator: operatorRef.current,
        bingoName: hallRef.current,
        sessionID: sessionRef.current,
        userInfo: parentInfoRef.current
          ? parentInfoRef.current
          : userInfoRef.current &&
              userInfoRef.current.username &&
              userInfoRef.current.username !== 'Gjest'
            ? userInfoRef.current
            : { id: '0', '7 digit PIN': 'Gjest' },
        totalAmount: papirScannedInfoRef.current.win,
      });
      return;
    }

    if (papirPrizeRef.current === 'xtipp') {
      socket.emit('payoutPapirXtippCard', {
        ticketID: papirScannedInfoRef.current.ticketID,
        prizes: papirScannedInfoRef.current.prizes,
        operator: operatorRef.current,
        bingoName: hallRef.current,
        sessionID: sessionRef.current,
        userInfo: parentInfoRef.current
          ? parentInfoRef.current
          : userInfoRef.current &&
              userInfoRef.current.username &&
              userInfoRef.current.username !== 'Gjest'
            ? userInfoRef.current
            : { id: '0', '7 digit PIN': 'Gjest' },
        totalAmount: papirScannedInfoRef.current.win,
      });
      return;
    }

    socket.emit('payoutPapirTicket', {
      ticketID: papirScannedInfoRef.current.ticketID,
      prizes: papirScannedInfoRef.current.prizes,
      operator: operatorRef.current,
      bingoName: hallRef.current,
      sessionID: sessionRef.current,
      userInfo: parentInfoRef.current
        ? parentInfoRef.current
        : userInfoRef.current &&
            userInfoRef.current.username &&
            userInfoRef.current.username !== 'Gjest'
          ? userInfoRef.current
          : { id: '0', '7 digit PIN': 'Gjest' },
      totalAmount: papirScannedInfoRef.current.win,
    });
  };

  const handleCancel = async () => {
    updatePapirScannedInfo(false);
    updateFocusOnMainScreen(true);
    updateShowModalPapirGameFinishedWithPrize(false);
  };

  const containerStyle = {
    width: 'min(860px, 94vw)',
    borderRadius: '24px',
    overflow: 'hidden',
    border: '1px solid rgba(255,255,255,0.12)',
    boxShadow: '0 30px 90px rgba(0,0,0,0.65)',
    backdropFilter: 'blur(14px)',
    WebkitBackdropFilter: 'blur(14px)',
    background: 'linear-gradient(135deg, rgba(18,26,55,0.98), rgba(10,14,28,0.98))',
    display: 'flex',
    flexDirection: 'column',
  };

  const overlayStyle = {
    background: 'rgba(3,6,18,0.88)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const confirmDisabled =
    (papirScannedInfoRef.current &&
      papirScannedInfoRef.current.win >= maximumAnonPrizeAllowedRef.current &&
      (((!userInfoRef.current || !userInfoRef.current.username) &&
        !parentInfoRef.current) ||
        (userInfoRef.current &&
          !parentInfoRef.current &&
          userInfoRef.current.username === 'Gjest'))) ||
    (papirScannedInfoRef.current && papirScannedInfoRef.current.isPayout);

  const checkCardButton = (
    <Button
      fullWidth
      variant="contained"
      onClick={() => {
        handleCheckCard();
      }}
      startIcon={<FlakyIcon sx={{ fontSize: 28 }} />}
      sx={{
        height: 76,
        borderRadius: '16px',
        bgcolor: 'rgba(255,255,255,0.08)',
        color: 'rgba(255,255,255,0.75)',
        fontWeight: 800,
        fontSize: 22,
        textTransform: 'uppercase',
        border: '1px solid rgba(255,255,255,0.14)',
        boxShadow: 'none',
        '&:hover': {
          bgcolor: 'rgba(255,255,255,0.14)',
          transform: 'translateY(-2px)',
          color: 'white',
        },
        '&:active': { transform: 'translateY(0)' },
      }}
    >
      {t('sales.checkCard')}
    </Button>
  );

  return (
    <>
      {kioskHallRef.current === '' ? (
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay" style={overlayStyle}>
            <div style={containerStyle}>
              {/* Header */}
              <Box
                sx={{
                  height: 70,
                  px: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: '1px solid rgba(255,255,255,0.10)',
                  background:
                    'linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))',
                  flexShrink: 0,
                }}
              >
                <Typography
                  sx={{ color: 'white', fontSize: '24px', fontWeight: 900, lineHeight: 1 }}
                >
                  {t('sales.papirGameFinishedWithPrizeTitle')}
                </Typography>
              </Box>

              {/* Body */}
              <Box sx={{ p: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Box
                  sx={{
                    borderRadius: '18px',
                    border: '1px solid rgba(255,255,255,0.14)',
                    background: 'rgba(255,255,255,0.06)',
                    p: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                  }}
                >
                  <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                    {t('sales.papirGameFinishedWithPrizeText1')}
                  </Typography>

                  {papirScannedInfoRef.current && (
                    <>
                      {papirScannedInfoRef.current.prizes.map(({ name, amount }, i) => (
                        <Typography key={i} sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                          {name !== '' && name + ':'}{' '}
                          <Box component="span" sx={{ color: 'white', fontWeight: 700 }}>
                            {amount} kr
                          </Box>
                        </Typography>
                      ))}

                      <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                        {t('sales.papirGameFinishedWithPrizeUserTotal')}:{' '}
                        <Box component="span" sx={{ color: '#FFC727', fontWeight: 700, fontSize: 24 }}>
                          {papirScannedInfoRef.current.win} kr
                        </Box>
                      </Typography>
                    </>
                  )}

                  {papirScannedInfoRef.current &&
                  !papirScannedInfoRef.current.isPayout ? (
                    <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                      {t('sales.papirGameFinishedWithPrizeText2')}
                    </Typography>
                  ) : (
                    <Typography sx={{ color: '#ff6b6b', fontWeight: 700, fontSize: 22 }}>
                      {t('sales.papirGameFinishedWithPrizeIsAlreadyPayed')}
                    </Typography>
                  )}

                  {papirScannedInfoRef.current &&
                    papirScannedInfoRef.current.win >= maximumAnonPrizeAllowedRef.current &&
                    !papirScannedInfoRef.current.isPayout && (
                      <Typography sx={{ color: '#ff6b6b', fontWeight: 700, fontSize: 22 }}>
                        {t('sales.papirGameFinishedWithPrizeUserMustBeLogin')}
                      </Typography>
                    )}
                </Box>

                <Box sx={{ display: 'flex', gap: '14px' }}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => { handleConfirm(); }}
                    startIcon={<CheckCircleIcon sx={{ fontSize: 28 }} />}
                    sx={{
                      height: 76,
                      borderRadius: '16px',
                      bgcolor: '#FFC727',
                      color: '#000',
                      fontWeight: 800,
                      fontSize: 22,
                      textTransform: 'uppercase',
                      boxShadow: '0 12px 32px rgba(255,199,39,0.4)',
                      opacity: confirmDisabled ? 0.25 : 1,
                      '&:hover': {
                        bgcolor: '#FFD54F',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 16px 40px rgba(255,199,39,0.55)',
                      },
                      '&:active': { transform: 'translateY(0)' },
                    }}
                  >
                    {t('sales.confirm')}
                  </Button>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => { handleCancel(); }}
                    startIcon={<CancelIcon sx={{ fontSize: 28 }} />}
                    sx={{
                      height: 76,
                      borderRadius: '16px',
                      bgcolor: 'rgba(255,255,255,0.08)',
                      color: 'rgba(255,255,255,0.75)',
                      fontWeight: 800,
                      fontSize: 22,
                      textTransform: 'uppercase',
                      border: '1px solid rgba(255,255,255,0.14)',
                      boxShadow: 'none',
                      '&:hover': {
                        bgcolor: 'rgba(255,255,255,0.14)',
                        transform: 'translateY(-2px)',
                        color: 'white',
                      },
                      '&:active': { transform: 'translateY(0)' },
                    }}
                  >
                    {t('sales.cancel')}
                  </Button>
                  {checkCardButton}
                </Box>
              </Box>
            </div>
          </div>
        </div>
      ) : (
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay" style={overlayStyle}>
            <div style={containerStyle}>
              {/* Header */}
              <Box
                sx={{
                  height: 70,
                  px: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: '1px solid rgba(255,255,255,0.10)',
                  background:
                    'linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))',
                  flexShrink: 0,
                }}
              >
                <Typography
                  sx={{ color: 'white', fontSize: '24px', fontWeight: 900, lineHeight: 1 }}
                >
                  {t('sales.papirGameFinishedWithPrizeTitle')}
                </Typography>
              </Box>

              {/* Body */}
              <Box sx={{ p: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Box
                  sx={{
                    borderRadius: '18px',
                    border: '1px solid rgba(255,255,255,0.14)',
                    background: 'rgba(255,255,255,0.06)',
                    p: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                  }}
                >
                  <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                    {t('sales.papirGameFinishedWithPrizeText1')}
                  </Typography>

                  {papirScannedInfoRef.current && (
                    <>
                      {papirScannedInfoRef.current.prizes.map(({ name, amount }, i) => (
                        <Typography key={i} sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                          {name !== '' && name + ':'}{' '}
                          <Box component="span" sx={{ color: 'white', fontWeight: 700 }}>
                            {amount} kr
                          </Box>
                        </Typography>
                      ))}

                      <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                        {t('sales.papirGameFinishedWithPrizeUserTotal')}:{' '}
                        <Box component="span" sx={{ color: '#FFC727', fontWeight: 700, fontSize: 24 }}>
                          {papirScannedInfoRef.current.win} kr
                        </Box>
                      </Typography>
                    </>
                  )}

                  {papirScannedInfoRef.current &&
                  !papirScannedInfoRef.current.isPayout ? (
                    <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                      {t('sales.papirGameFinishedWithPrizeText3')}
                    </Typography>
                  ) : (
                    <Typography sx={{ color: '#ff6b6b', fontWeight: 700, fontSize: 22 }}>
                      {t('sales.papirGameFinishedWithPrizeIsAlreadyPayed')}
                    </Typography>
                  )}
                </Box>

                <Box sx={{ display: 'flex', gap: '14px' }}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => { handleCancel(); }}
                    startIcon={<CheckCircleIcon sx={{ fontSize: 28 }} />}
                    sx={{
                      height: 76,
                      borderRadius: '16px',
                      bgcolor: '#FFC727',
                      color: '#000',
                      fontWeight: 800,
                      fontSize: 22,
                      textTransform: 'uppercase',
                      boxShadow: '0 12px 32px rgba(255,199,39,0.4)',
                      '&:hover': {
                        bgcolor: '#FFD54F',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 16px 40px rgba(255,199,39,0.55)',
                      },
                      '&:active': { transform: 'translateY(0)' },
                    }}
                  >
                    {t('sales.confirm')}
                  </Button>
                  {checkCardButton}
                </Box>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ModalPapirGameFinishedWithPrize;
